import { Fragment } from "react";
import styled, { css } from "styled-components";
import Block from "components/layout/Block";
import Text from "components/typography/Text";
import { useTranslation } from "react-i18next";
import { Icon } from "components/icons";

// #####################################################

const SelectorSectionStyled = styled.div`
	display: flex;
	justify-content: space-between;
	flex: 1;
	flex-direction: column;
	position: relative;
	text-align: left;
	width: 100%;
	align-items: center;
	color: var(--dz-sys-text-color);
	border-radius: var(--dz-sys-input-border-radius);
	overflow: hidden;
	transition: box-shadow 100ms;
	border: 1px solid var(--dz-sys-input-border-color);

	${({ $isOpen }) =>
		$isOpen &&
		css`
			box-shadow: var(--dz-ref-shadow-input-bottom);
			border: 1px solid var(--dz-sys-input-border-color-hover);
		`}

	&:hover,
	&:focus-within,
	&:focus-visible {
		box-shadow: var(--dz-ref-shadow-input-bottom);
		border: 1px solid var(--dz-sys-input-border-color-hover);
	}
`;

const SelectorWrapperStyled = styled.div`
	position: relative;
	display: flex;
	min-width: fit-content;
	margin: 0 1rem 0.75rem 1rem;
	cursor: pointer;
	border-radius: var(--dz-sys-input-border-radius);
`;

const StyledSelectorLabel = styled(Text)`
	display: flex;
	flex-direction: column;
	flex: 1;
	align-items: flex-start;
	pointer-events: none;
	font-size: 0.8rem;
	line-height: 12px;
	background: transparent;
	user-select: none;
	margin-right: 1rem;
`;

const StyledBottomLabeltextWrapper = styled(Block)`
	display: flex;
	flex-wrap: wrap;
	min-height: 16px;
	margin-top: 3px;
	font-size: 1rem;
	line-height: 1.5;

	${({ $isSelected }) =>
		$isSelected &&
		css`
			font-weight: bold;
		`}
`;

const StyledSelectorLabelWrapper = styled(Block)`
	display: flex;
	flex-wrap: wrap;
	padding: 0.5rem 1rem;
	width: 100%;
	min-height: 31px;
	align-items: center;
`;

// #####################################################

export const PreferencesActivatorChildMulti = ({
	label,
	onClick,
	isOpen,
	isSelected = false,
	children,
	selected,
}) => {
	const { t } = useTranslation(["common"]);
	const selectedLimitText = t("userpanel:data.cantSaveMorePreferences");
	const customSelectedLimitText = selectedLimitText?.replace(/10/g, "20");
	const emptyText = t("common:choose");

	const renderBottomLabeltext = () => {
		if (selected.length === 0) {
			return <Text color="grey">{emptyText}</Text>;
		}
		if (selected.length === 20) {
			return customSelectedLimitText;
		}
		return selected.map((item, index) => {
			return (
				<Fragment key={item.key || index}>
					{/* Text wrapper is used to prevent insertBefore error on translation. */}
					<Text>{item.content}</Text>
					{index + 1 < selected.length && <Text mr={1}>,</Text>}
				</Fragment>
			);
		});
	};

	return (
		<SelectorWrapperStyled className="SelectorWrapperStyled">
			<SelectorSectionStyled $isOpen={isOpen}>
				<StyledSelectorLabelWrapper onClick={onClick}>
					<StyledSelectorLabel>
						<Block flex>{label}</Block>
						<StyledBottomLabeltextWrapper $isSelected={isSelected}>
							{renderBottomLabeltext()}
						</StyledBottomLabeltextWrapper>
					</StyledSelectorLabel>

					<Icon name={isOpen ? "caret-up" : "caret-down"} />
				</StyledSelectorLabelWrapper>
				<Block flex fullWidth>
					{children}
				</Block>
			</SelectorSectionStyled>
		</SelectorWrapperStyled>
	);
};
